// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Report, {getDefaultState as getReportDefaultState} from './report';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    criteria: t.String,
    gridApi: t.Object,
    report: Report,
    reportIsScrollable: t.Boolean,
    showNoResultsFound: t.Boolean
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        criteria: '',
        gridApi: {},
        report: getReportDefaultState(),
        reportIsScrollable: false,
        showNoResultsFound: false
    });

export default State;



// WEBPACK FOOTER //
// ./src/reports/pip-history/state/index.js